import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { CustomDialogComponent } from './components/custom-dialog/custom-dialog.component';
import { SubmitterDetailsDialogueComponent } from './../features/analytics/components/submitter-details-dialogue/submitter-details-dialogue.component';
import { APIsEndPoints } from '../utilities/apis.endpoints';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomDialogService {

  errorArray : any = [];
  submitterCrewId = '';
  submitterRank = '';
  submitterName = '';
  submitterProfileImage: any;
  constructor(private ngbModal: NgbModal,private http: HttpClient) { }

  showDialog(message: string, actionType: string): Observable<any> {
    const modalRef = this.ngbModal.open(CustomDialogComponent, {size: 'md'} );
    modalRef.componentInstance.actionType = actionType;
    modalRef.componentInstance.message = message;
    return modalRef.componentInstance.action$;
    
  }

  showSafetyChampionDialog(mainText: string,subText:string,lastText:string,actionType: string): Observable<any> {
    const modalRef = this.ngbModal.open(CustomDialogComponent, {size: 'md'} );
    modalRef.componentInstance.actionType = actionType;
    modalRef.componentInstance.mainText = mainText;
    modalRef.componentInstance.subText = subText;
    modalRef.componentInstance.lastText = lastText;
    return modalRef.componentInstance.action$;
    
  }

  showShortListedDialog(shortList: any[], actionType: string): Observable<any> {
    const modalRef = this.ngbModal.open(CustomDialogComponent, {size: 'md'} );
    modalRef.componentInstance.actionType = actionType;
    modalRef.componentInstance.shortList = shortList;
    return modalRef.componentInstance.action$;
    
  }

  showDialogBackDrop(message: string, actionType: string): Observable<any> {
    const modalRef = this.ngbModal.open(CustomDialogComponent, {size: 'md',backdrop: 'static',keyboard: false} );
    modalRef.componentInstance.actionType = actionType;
    modalRef.componentInstance.message = message;
    return modalRef.componentInstance.action$;
    
  }

  setErrorArray(errors: any){
    this.errorArray = errors;
  }

  getErrorArray(){
    return this.errorArray;
  }

  showBulkUploadDialog(message: string,bulkErrorMessage: any, actionType: string): Observable<any> {
    const modalRef = this.ngbModal.open(CustomDialogComponent, {size: 'md'} );
    modalRef.componentInstance.actionType = actionType;
    this.setErrorArray(bulkErrorMessage);
    modalRef.componentInstance.message = message;
    return modalRef.componentInstance.action$;
    
  }
  showSafetyChampionErrorDialog(mainText: string,subText:string,lastText:string,actionType: string): Observable<any> {
    const modalRef = this.ngbModal.open(CustomDialogComponent, {size: 'md'} );
    modalRef.componentInstance.actionType = actionType;
    modalRef.componentInstance.mainText = mainText;
    modalRef.componentInstance.subText = subText;
    modalRef.componentInstance.lastText = lastText;
    return modalRef.componentInstance.action$;
    
  }
  showRatingScaleDialogue(message: string, actionType: string): Observable<any> {
    const modalRef = this.ngbModal.open(CustomDialogComponent, {size: 'sm'} );
    modalRef.componentInstance.actionType = actionType;
    modalRef.componentInstance.message = message;
    return modalRef.componentInstance.action$;    
  }

  showSubmitterDetailsDialogue(message: string,crewId: string,rank: string,name: string, actionType: string): Observable<any> {
    this.submitterCrewId = crewId;
    this.submitterRank = rank;
    this.submitterName = name;
    // this.submitterProfileImage = profileImage;
    console.log('img ', this.submitterProfileImage);
    const modalRef = this.ngbModal.open(SubmitterDetailsDialogueComponent, {size: 'sm'} );
    // modalRef.componentInstance.actionType = actionType;
    // modalRef.componentInstance.message = message;
    return modalRef.componentInstance.action$;    
  }

  setSubmitterImage(data: any){
    this.submitterProfileImage = data;
  }

  getSubmitterDetails(){
    let submitterData = {crewId: this.submitterCrewId , rank: this.submitterRank , name: this.submitterName,image: this.submitterProfileImage};
    console.log('get submitter data ', submitterData);
    return submitterData;
  }
    
}
